module Meevo.Plugins.AddOnGroup {
    "use strict";
    /**
     * ServiceAddOnTime Section of AddOnGroup
     */
    export class ServiceAddOnTimeSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.IAddOnGroupServiceAddOnStepTime> {

        public services = null;
        public steps = null;
        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );


        }

        /**
         * The tab is activated
         */
        activate(): void {
            super.activate();
            this.init()
        }

        init(): void {
            this.model.serviceAddOnStepTimes.forEach(
                s => s.show = (
                    s.addOnServiceStepTimes.length > 0 &&
                    s.addOnServiceStepTimes.some(addOn => parseInt(addOn.extraTimeForServiceAsAddOnInMin) > 0)
                )
            )
            this.model.serviceAddOnStepTimes.forEach(s => s.expand = true)
        }

        get isAnyAddOnServiceStepTime(): boolean {
            return !!this.model && this.model.serviceAddOnStepTimes.some(s => s.show === true);
        }

        sectionModelRetrieved(): void {
            super.sectionModelRetrieved();
            this.init();
        }

        allToSameStep(service: Model.IServiceAddOnStepTimes): void {
            const srv = this.model.serviceAddOnStepTimes.find(s => s.serviceId === service.serviceId);
            srv.addOnServiceStepTimes.forEach(a => a.stepId = service.all);
        }

        setOne(service: Model.IServiceAddOnStepTimes): void {
            const srv = this.model.serviceAddOnStepTimes.find(s => s.serviceId === service.serviceId);
            const found = srv.addOnServiceStepTimes.filter(s=> s.stepId !== service.all)
            if (!!found) {
                service.all = null;
            }
        }

        toggleExpand(service: Model.IServiceAddOnStepTimes): void {
            service.expand = !service.expand;
        }

        toggleAllAddOnDropdown(AllAddOnsSelector) {
            if (!AllAddOnsSelector.dropdown) {
                AllAddOnsSelector.dropdown = true;
            } else {
                AllAddOnsSelector.dropdown = !AllAddOnsSelector.dropdown;
            }
        }

        isMobile(): boolean {
            return window.innerWidth <= 600 ? true: false;
        }
        preSave(): void {
            super.preSave();
        }

    }
}